// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CohortDevelopmentsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CohortDevelopmentsQuery = { __typename?: 'Query', cohorts: Array<{ __typename?: 'Cohort', createdAt: Types.Scalars['DateTime']['input'], id: string, name: string, market: { __typename?: 'Market', id: string }, development?: { __typename?: 'Development', createdAt: Types.Scalars['DateTime']['input'], id: string, name: string } | null | undefined }> };

export type CohortDevelopmentDetailsFragment = { __typename?: 'Cohort', createdAt: Types.Scalars['DateTime']['input'], id: string, name: string, market: { __typename?: 'Market', id: string }, development?: { __typename?: 'Development', createdAt: Types.Scalars['DateTime']['input'], id: string, name: string } | null | undefined };

export const CohortDevelopmentDetailsFragmentDoc = gql`
    fragment CohortDevelopmentDetails on Cohort {
  ...Named
  createdAt
  market {
    id
  }
  development {
    createdAt
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const CohortDevelopmentsDocument = gql`
    query CohortDevelopments {
  cohorts {
    ...CohortDevelopmentDetails
  }
}
    ${CohortDevelopmentDetailsFragmentDoc}`;

/**
 * __useCohortDevelopmentsQuery__
 *
 * To run a query within a React component, call `useCohortDevelopmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortDevelopmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCohortDevelopmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCohortDevelopmentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CohortDevelopmentsQuery, CohortDevelopmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CohortDevelopmentsQuery, CohortDevelopmentsQueryVariables>(CohortDevelopmentsDocument, options);
      }
export function useCohortDevelopmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CohortDevelopmentsQuery, CohortDevelopmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CohortDevelopmentsQuery, CohortDevelopmentsQueryVariables>(CohortDevelopmentsDocument, options);
        }
// @ts-ignore
export function useCohortDevelopmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CohortDevelopmentsQuery, CohortDevelopmentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CohortDevelopmentsQuery, CohortDevelopmentsQueryVariables>;
export function useCohortDevelopmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CohortDevelopmentsQuery, CohortDevelopmentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CohortDevelopmentsQuery | undefined, CohortDevelopmentsQueryVariables>;
export function useCohortDevelopmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CohortDevelopmentsQuery, CohortDevelopmentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CohortDevelopmentsQuery, CohortDevelopmentsQueryVariables>(CohortDevelopmentsDocument, options);
        }
export type CohortDevelopmentsQueryHookResult = ReturnType<typeof useCohortDevelopmentsQuery>;
export type CohortDevelopmentsLazyQueryHookResult = ReturnType<typeof useCohortDevelopmentsLazyQuery>;
export type CohortDevelopmentsSuspenseQueryHookResult = ReturnType<typeof useCohortDevelopmentsSuspenseQuery>;
export type CohortDevelopmentsQueryResult = Apollo.QueryResult<CohortDevelopmentsQuery, CohortDevelopmentsQueryVariables>;